const tickerRegexTest = (ticker: string) => {
  const regex = /^\w+:\w+(\.\w+)?\.?$/;
  return regex.test(ticker);
};

export default tickerRegexTest;
